export default __webpack_public_path__ + "static/tesco.url-cf28dd97179b81ccebb0b8fe1e14317e.svg";